import { eraseCookie, readCookie } from '@utils/cookies';

// eslint-disable-next-line import/prefer-default-export
export const removeKeyFromCookie = (key) => {
  const data = readCookie(key);
  if (data) {
    eraseCookie(key);
  }
};
